import { render, staticRenderFns } from "./MyListItem.vue?vue&type=template&id=5571772e&scoped=true"
import script from "./MyListItem.vue?vue&type=script&lang=js"
export * from "./MyListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571772e",
  null
  
)

export default component.exports